import { Link } from "@inertiajs/react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export default function Breadcrumbs({ breadcrumbs = [] }) {
  return (
    <Breadcrumb>
      <BreadcrumbList itemScope itemType="https://schema.org/BreadcrumbList">
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = breadcrumbs.length - 1 === index;
          return (
            <>
              <BreadcrumbItem
                key={`breadcrumb-${index}`}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <BreadcrumbLink href="/" asChild>
                  <Link href={breadcrumb.href} itemProp="item">
                    <span itemProp="name">{breadcrumb.name}</span>
                    <meta itemProp="position" content={index + 1} />
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator />}
            </>
          );
        })}
        <BreadcrumbPage />
      </BreadcrumbList>
    </Breadcrumb>
  );
}
